import React from "react";
import { useNavigate } from "react-router-dom";
import "../styling/pagenotfound.css";
import { FaHome, FaExclamationTriangle } from "react-icons/fa";

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="notfound-wrapper">
      <div className="notfound-card">
        <FaExclamationTriangle className="notfound-icon" />

        <h1>404</h1>
        <h2>Page Not Found</h2>

        <p>
          Sorry, the page you are looking for doesn’t exist or has been moved.
        </p>

        <button className="primary-btn" onClick={() => navigate("/loanlist")}>
          <FaHome /> Go to Dashboard
        </button>
      </div>
    </div>
  );
};

export default NotFound;
